import { actionCreator } from '@ardoq/rxbeach';
import { ArdoqId, FilterInterfaceFilter } from '@ardoq/api-types';
import { FiltersAsQueryBuilderQueries } from '@ardoq/filter-interface';

interface FilterChangePayload {
  readonly filters: FiltersAsQueryBuilderQueries;
  readonly queryString: string;
}

export const notifyFiltersChanged = actionCreator<FilterChangePayload>(
  '[FilterActions] NOTIFY_FILTERS_CHANGED'
);
/** Triggered when color filters are changed */
export const notifyFilterColorChanged = actionCreator(
  '[FilterActions] NOTIFY_FILTER_COLOR_CHANGED'
);
export const triggerFiltersChangedEvent = actionCreator(
  '[FilterActions] TRIGGER_FILTERS_CHANGED_EVENT'
);

export const setActivePerspective = actionCreator<{
  id: ArdoqId | null;
  queryString: string;
}>('[FilterActions] SET_ACTIVE_PERSPECTIVE');

export const notifyPerspectivesDestroyed = actionCreator<{
  perspectiveIds: ArdoqId[];
}>('[FilterActions] NOTIFY_PERSPECTIVE_DESTROYED');

export const notifyFilterContextChanged = actionCreator(
  '[FilterActions] NOTIFY_FILTER_CONTEXT_CHANGED'
);

export const notifyPerspectivesProcessedChangedWorkspace = actionCreator(
  '[Perspectives] NOTIFY_PERSPECTIVES_PROCESSED_CHANGED_WORKSPACE'
);

export const updateFiltered = actionCreator<{ componentId: ArdoqId }>(
  '[FilterActions] UPDATE_FILTERED'
);

export type CreateFilterRequestedPayload = Omit<
  FilterInterfaceFilter,
  'type'
> & {
  filterName?: string;
};

export const createFilterRequested =
  actionCreator<CreateFilterRequestedPayload>(
    '[FilterActions] CREATE_FILTER_REQUESTED'
  );

export const includeComponentTypeRequested = actionCreator<string>(
  '[FilterActions] INCLUDE_COMPONENT_TYPE_REQUESTED'
);

export const includeReferenceTypeRequested = actionCreator<string>(
  '[FilterActions] INCLUDE_REFERENCE_TYPE_REQUESTED'
);
